import React, { Component, useEffect, useState } from "react";
import CodeBlock from "../../common/code_block";
import HeaderWithTag from "../../common/header_with_tag";
import TrySendRemittance from "./try";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import { Link } from 'react-router-dom';
import { IRemittanceDto, PaymentMethod, SenderTypes } from "../../types/types";
import { HOST_API_URL } from "../../config";

const requestCode: IRemittanceDto = {
  requestUniqueId: "REQ123456789",
  paymentMethod: PaymentMethod.CASH,
  sender: {
    id: "SENDER001",
    name: "Abdirazak Ibrahim Abdirahman",
    phone: "252654249184",
    city: "Hargeisa",
    address: "2nd Floor, eDahab Building, Hargeisa Main Road",
    country: "Somalia",
    state: "Marodi-Jeh",
    postCode: "2112",
    nationality: "Somali",
    documentType: "Passport",
    documentNumber: "0145221564521",
    issueDate: "2023-09-01T00:00:00Z",
    expireDate: "2025-09-01T00:00:00Z",
    dateOfBirth: "1990-09-01T00:00:00Z",
    placeOfBirth: "Burao",
    gender: "Male",
    occupation: "Engineer",
    senderType: SenderTypes.INDIVIDUAL,
    sourceOfFund: "Salary"
  },
  receiver: {
    id: "REC001",
    name: "Jama Ali Warsame",
    destinationAgent: "TST",
    phone: "252659114455",
    address: "",
    nationality: "Somali",
    receiverRelationship: "Friend"
  },
  bankDetails: {
    accountId: "HRGD123456",
    bankCode: "BANK001",
    bankSwift: "SWIFT001"
  },
  amount: 100.0,
  origRefNumber: "ORIG123456",
  currencyCode: "USD",
  Purpose: "Education fees",
  narration: "Sending money to family",
  payoutAmount: 100.0,
  commission: 0.5
};

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "transactionId": "XRT00020675"
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Insufficient balance to process this remittance",
  "errorCode": "DPI-3001",
  "data": null
}`;

function SendRemittance() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Send Remittance</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Send Remittance
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Initiate a remittance"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          POST
                        </span>
                        {HOST_API_URL}/Remittances/SendRemittance
                      </p>
                      <p
                        className="text-muted text-14"
                        style={{ textAlign: "justify" }}
                      >
                        Submit a new remittance transaction. Provide full sender and receiver details,
                        amounts, and required documentary information. A successful response returns
                        a transaction identifier you can use to query status or perform follow‑up actions.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Request"
                          headerTag="request"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameter</th>
                                <th>Type</th>
                                <th>Description</th>
                                <th>Required</th>
                                <th>Min</th>
                                <th>Max</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>requestUniqueId</td>
                                <td>string</td>
                                <td>Unique request identifier</td>
                                <td>Yes</td>
                                <td>1</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>paymentMethod</td>
                                <td>string</td>
                                <td>Payment method (Cash, Wallet, Bank)</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender</td>
                                <td>object</td>
                                <td>Sender details</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.id</td>
                                <td>string</td>
                                <td>Sender ID</td>
                                <td>Yes</td>
                                <td>1</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>sender.name</td>
                                <td>string</td>
                                <td>Sender's full name</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>100</td>
                              </tr>
                              <tr>
                                <td>sender.phone</td>
                                <td>string</td>
                                <td>Sender's phone</td>
                                <td>Yes</td>
                                <td>7</td>
                                <td>15</td>
                              </tr>
                              <tr>
                                <td>sender.city</td>
                                <td>string</td>
                                <td>Sender's city</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.address</td>
                                <td>string</td>
                                <td>Sender's address</td>
                                <td>Yes</td>
                                <td>5</td>
                                <td>200</td>
                              </tr>
                              <tr>
                                <td>sender.country</td>
                                <td>string</td>
                                <td>Sender's country</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.state</td>
                                <td>string</td>
                                <td>Sender's state</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.postCode</td>
                                <td>string</td>
                                <td>Sender's postal code</td>
                                <td>No</td>
                                <td>3</td>
                                <td>10</td>
                              </tr>
                              <tr>
                                <td>sender.nationality</td>
                                <td>string</td>
                                <td>Sender's nationality</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.documentType</td>
                                <td>string</td>
                                <td>Document type</td>
                                <td>Yes</td>
                                <td>3</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>sender.documentNumber</td>
                                <td>string</td>
                                <td>Document number</td>
                                <td>Yes</td>
                                <td>5</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>sender.issueDate</td>
                                <td>string</td>
                                <td>Document issue date</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.expireDate</td>
                                <td>string</td>
                                <td>Document expiry date</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.dateOfBirth</td>
                                <td>string</td>
                                <td>Sender's date of birth</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.placeOfBirth</td>
                                <td>string</td>
                                <td>Place of birth</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.gender</td>
                                <td>string</td>
                                <td>Gender</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.occupation</td>
                                <td>string</td>
                                <td>Occupation</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.senderType</td>
                                <td>string</td>
                                <td>Sender type (Individual, Corporate, Charity)</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.sourceOfFund</td>
                                <td>string</td>
                                <td>Source of fund</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>sender.additionalField1</td>
                                <td>string</td>
                                <td>Spare field for corridor-specific data</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>sender.additionalField2</td>
                                <td>string</td>
                                <td>Spare field for corridor-specific data</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>receiver</td>
                                <td>object</td>
                                <td>Receiver details</td>
                                <td>Yes</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>receiver.id</td>
                                <td>string</td>
                                <td>Receiver ID</td>
                                <td>Yes</td>
                                <td>1</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>receiver.name</td>
                                <td>string</td>
                                <td>Receiver's name</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>100</td>
                              </tr>
                              <tr>
                                <td>receiver.destinationAgent</td>
                                <td>string</td>
                                <td>Destination agent</td>
                                <td>Yes</td>
                                <td>3</td>
                                <td>3</td>
                              </tr>
                              <tr>
                                <td>receiver.phone</td>
                                <td>string</td>
                                <td>Receiver's phone</td>
                                <td>Yes</td>
                                <td>7</td>
                                <td>15</td>
                              </tr>
                              <tr>
                                <td>receiver.address</td>
                                <td>string</td>
                                <td>Receiver's address</td>
                                <td>No</td>
                                <td>5</td>
                                <td>200</td>
                              </tr>
                              <tr>
                                <td>receiver.nationality</td>
                                <td>string</td>
                                <td>Receiver's nationality</td>
                                <td>Yes</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>receiver.receiverRelationship</td>
                                <td>string</td>
                                <td>Relationship to sender</td>
                                <td>No</td>
                                <td>2</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>receiver.additionalField1</td>
                                <td>string</td>
                                <td>Spare field for corridor-specific data</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>receiver.additionalField2</td>
                                <td>string</td>
                                <td>Spare field for corridor-specific data</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>bankDetails</td>
                                <td>object</td>
                                <td>Bank details</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>bankDetails.accountId</td>
                                <td>string</td>
                                <td>Account ID</td>
                                <td>No</td>
                                <td>5</td>
                                <td>20</td>
                              </tr>
                              <tr>
                                <td>bankDetails.bankCode</td>
                                <td>string</td>
                                <td>Bank code</td>
                                <td>No</td>
                                <td>3</td>
                                <td>10</td>
                              </tr>
                              <tr>
                                <td>bankDetails.bankSwift</td>
                                <td>string</td>
                                <td>Bank SWIFT / code</td>
                                <td>No</td>
                                <td>8</td>
                                <td>11</td>
                              </tr>
                              <tr>
                                <td>amount</td>
                                <td>decimal</td>
                                <td>
                                  Sending amount. Up to 4 decimal places. No maximum is
                                  enforced by the API.
                                </td>
                                <td>Yes</td>
                                <td>0.01</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>origRefNumber</td>
                                <td>string</td>
                                <td>Original reference number</td>
                                <td>Yes</td>
                                <td>1</td>
                                <td>50</td>
                              </tr>
                              <tr>
                                <td>CurrencyCode</td>
                                <td>string</td>
                                <td>Currency code</td>
                                <td>No</td>
                                <td>3</td>
                                <td>3</td>
                              </tr>
                              <tr>
                                <td>Purpose</td>
                                <td>string</td>
                                <td>Purpose of remittance. Free text.</td>
                                <td>No</td>
                                <td></td>
                                <td>100</td>
                              </tr>
                              <tr>
                                <td>narration</td>
                                <td>string</td>
                                <td>Narration</td>
                                <td>No</td>
                                <td>0</td>
                                <td>500</td>
                              </tr>
                              <tr>
                                <td>payoutAmount</td>
                                <td>decimal</td>
                                <td>
                                  Amount disbursed to the beneficiary. Optional in the
                                  schema, but populate it whenever the beneficiary payout
                                  differs from <code>amount</code> &mdash; there is no
                                  other field for this value.
                                </td>
                                <td>No</td>
                                <td>0.01</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>bankAccount</td>
                                <td>string</td>
                                <td>Destination bank account reference</td>
                                <td>No</td>
                                <td></td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>commission</td>
                                <td>decimal</td>
                                <td>Commission amount</td>
                                <td>No</td>
                                <td>0.01</td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={JSON.stringify(requestCode, null, 2)}
                          codeBlackText="Request"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>statusCode</td>
                                <td>integer</td>
                                <td>200 on success, otherwise the failure status</td>
                              </tr>
                              <tr>
                                <td>message</td>
                                <td>string</td>
                                <td>"Success", or the reason for the failure</td>
                              </tr>
                              <tr>
                                <td>errorCode</td>
                                <td>string</td>
                                <td>null on success; a stable DPI-xxxx code on failure</td>
                              </tr>
                              <tr>
                                <td>data.transactionId</td>
                                <td>string</td>
                                <td>Transaction ID (TTNO) of the submitted remittance</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Field Validation Codes"
                          headerTag="fieldCodes"
                        />
                        <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                          Each required field maps to its own code, so you can point a
                          failed submission at the exact field without parsing the message
                          text.
                        </p>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Field</th>
                                <th className="text-nowrap">Code</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>requestUniqueId</td>
                                <td className="text-nowrap">DPI-1001</td>
                              </tr>
                              <tr>
                                <td>origRefNumber</td>
                                <td className="text-nowrap">DPI-1002</td>
                              </tr>
                              <tr>
                                <td>amount</td>
                                <td className="text-nowrap">DPI-1003 / DPI-1004</td>
                              </tr>
                              <tr>
                                <td>paymentMethod</td>
                                <td className="text-nowrap">DPI-1005</td>
                              </tr>
                              <tr>
                                <td>sender</td>
                                <td className="text-nowrap">DPI-1050</td>
                              </tr>
                              <tr>
                                <td>sender.id</td>
                                <td className="text-nowrap">DPI-1010</td>
                              </tr>
                              <tr>
                                <td>sender.name</td>
                                <td className="text-nowrap">DPI-1011</td>
                              </tr>
                              <tr>
                                <td>sender.phone</td>
                                <td className="text-nowrap">DPI-1012 / DPI-1013</td>
                              </tr>
                              <tr>
                                <td>sender.documentType</td>
                                <td className="text-nowrap">DPI-1014 / DPI-1015</td>
                              </tr>
                              <tr>
                                <td>sender.city</td>
                                <td className="text-nowrap">DPI-1016</td>
                              </tr>
                              <tr>
                                <td>sender.address</td>
                                <td className="text-nowrap">DPI-1017</td>
                              </tr>
                              <tr>
                                <td>sender.country</td>
                                <td className="text-nowrap">DPI-1018</td>
                              </tr>
                              <tr>
                                <td>sender.documentNumber</td>
                                <td className="text-nowrap">DPI-1019</td>
                              </tr>
                              <tr>
                                <td>sender.issueDate</td>
                                <td className="text-nowrap">DPI-1040</td>
                              </tr>
                              <tr>
                                <td>sender.expireDate</td>
                                <td className="text-nowrap">DPI-1041</td>
                              </tr>
                              <tr>
                                <td>sender.dateOfBirth</td>
                                <td className="text-nowrap">DPI-1042</td>
                              </tr>
                              <tr>
                                <td>receiver</td>
                                <td className="text-nowrap">DPI-1051</td>
                              </tr>
                              <tr>
                                <td>receiver.id</td>
                                <td className="text-nowrap">DPI-1020</td>
                              </tr>
                              <tr>
                                <td>receiver.name</td>
                                <td className="text-nowrap">DPI-1021</td>
                              </tr>
                              <tr>
                                <td>receiver.phone</td>
                                <td className="text-nowrap">DPI-1022 / DPI-1023</td>
                              </tr>
                              <tr>
                                <td>receiver.nationality</td>
                                <td className="text-nowrap">DPI-1024</td>
                              </tr>
                              <tr>
                                <td>receiver.destinationAgent</td>
                                <td className="text-nowrap">DPI-1025 / DPI-1026</td>
                              </tr>
                              <tr>
                                <td>bankDetails</td>
                                <td className="text-nowrap">DPI-1030</td>
                              </tr>
                              <tr>
                                <td>bankDetails.accountId</td>
                                <td className="text-nowrap">DPI-1031</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="alert alert-info text-14">
                          <strong>Malformed values fail earlier.</strong> An unrecognised
                          enum value, a non-numeric amount or an unparseable date is
                          rejected during model binding with <code>DPI-1006</code>, before
                          any of the checks above run.
                        </div>

                        <div className="alert alert-warning text-14 mb-0">
                          <strong>Destination agents can require extra fields.</strong> The
                          value you send in <code>receiver.destinationAgent</code>
                          determines an additional, agent-specific set of required fields.
                          You may therefore receive
                          <code> "&lt;Field&gt; is required"</code> errors for fields marked
                          optional in the table above. Several such errors are joined into
                          one <code>message</code>, separated by <code>;</code>, and
                          <code> errorCode</code> reflects the first of them.
                        </div>
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                    Code Samples
                  </h5>

                  <TrySendRemittance
                    codeBlackTitle="Request Example"
                    sendRemittanceObject={requestCode}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendRemittance;
